import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import PlannedQuestionnairesWrapper from './PlannedQuestionnairesWrapper';

loadDOMComponent({
	selector: 'react-planned-questionnaires-wrapper',
	callback: ({ container, context, props }: any) => {
		const patientId = container.getAttribute('patientId');
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<PlannedQuestionnairesWrapper patientId={patientId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
